import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "10",
  height: "18",
  fill: "none",
  viewBox: "0 0 10 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M4.521 17.35A.8.8 0 0 0 5 17.54a.61.61 0 0 0 .472-.185l2.112-2.112a.64.64 0 0 0 .191-.478.64.64 0 0 0-.198-.472l-1.06-1.053 1.545-1.538a.62.62 0 0 0 .192-.472.67.67 0 0 0-.198-.478L6.627 9.317Q8.035 8.641 8.8 7.533q.765-1.107.765-2.468 0-.943-.355-1.77a4.6 4.6 0 0 0-.984-1.456Q7.605 1.209 6.77.86A4.4 4.4 0 0 0 5 .506 4.5 4.5 0 0 0 3.216.86a4.5 4.5 0 0 0-1.456.978q-.63.622-.985 1.45a4.5 4.5 0 0 0-.348 1.776q0 .917.328 1.737.335.813.943 1.449.609.636 1.443 1.005v6.453q0 .17.054.349a.7.7 0 0 0 .212.314zM5 16.27l-.759-.752V8.463a3.4 3.4 0 0 1-1.415-.67 3.5 3.5 0 0 1-.964-1.196 3.46 3.46 0 0 1-.341-1.532q0-.717.266-1.34.273-.629.745-1.1A3.5 3.5 0 0 1 3.64 1.88 3.4 3.4 0 0 1 5 1.606q.958 0 1.743.465.793.465 1.258 1.251a3.36 3.36 0 0 1 .465 1.743q0 .814-.356 1.525-.348.705-.99 1.21-.637.506-1.491.71v1.382l1.34 1.346-1.45 1.429v1.135l.971.957zM5 5.127q.513 0 .875-.362a1.2 1.2 0 0 0 .362-.882q0-.513-.362-.875A1.2 1.2 0 0 0 5 2.646a1.2 1.2 0 0 0-.882.362 1.18 1.18 0 0 0-.362.875q0 .519.362.882A1.2 1.2 0 0 0 5 5.127"
    }, null, -1)
  ])))
}
export default { render: render }